/*
  * Query used to fetch business nfo
  * Below are the list of services that it talks to:
      * AWSSCMRFXService
  */
import { gql } from '@apollo/client';

import { RFXBusinessInfoTemplate } from '../../interfaces/RFXBusinessModel';

export interface GetBusinessInfoQueryResult {
  getRFXBusinessInfo: {
    template: RFXBusinessInfoTemplate,
    quoteValidityInfo: {
      stringifiedRegionToAreaMap: string,
      stringifiedQuoteValidityTable: string,
    }
  }
};

export const getRFXBusinessInfoQuery = gql`
 query getRFXBusinessInfo(
   $businessId: String!
 ){
   getRFXBusinessInfo(businessId: $businessId){
     template{
       templateType
       templateOptions {
         categoryOptions {
           optionType
           stringifiedOption
         }
         regionOptions {
           optionType
           stringifiedOption
         }
         currencyOptions {
           optionType
           stringifiedOption
         }
         organizationOptions {
           optionType
           stringifiedOption
         }
       }
     }
     quoteValidityInfo {
      stringifiedRegionToAreaMap
      stringifiedQuoteValidityTable
     }
   }
 }
 `;
